import { type FC, useState } from "react";
import { cn } from "@/components/podkit/lib/cn";
import { MarkdownCopyablePre } from "@/components/ai/chat/MarkdownCopyablePre";
import { Code, FileText } from "lucide-react";
import { Tabs, TabsList, TabsTrigger } from "@/components/flexkit/tabs/Tabs";
import { WorkflowPreview } from "@/routes/environments/code-changes/WorkflowPreview";
import type { BaseIconProps } from "@/assets/icons/utils";

type WorkflowCodePreviewProps = {
    content: string;
    className?: string;
};

// Icon wrappers for TabsTrigger compatibility
const CodeIcon: FC<BaseIconProps> = ({ size: _size = "sm", ...props }) => <Code size={16} {...props} />;
const FileTextIcon: FC<BaseIconProps> = ({ size: _size = "sm", ...props }) => <FileText size={16} {...props} />;

export const WorkflowCodePreview: FC<WorkflowCodePreviewProps> = ({ content, className = "" }) => {
    const [isPreviewMode, setIsPreviewMode] = useState(true);

    return (
        <div className={cn("my-4", className)}>
            <Tabs
                value={isPreviewMode ? "preview" : "code"}
                onValueChange={(value) => setIsPreviewMode(value === "preview")}
                className="w-full"
            >
                <TabsList className="w-fit">
                    <TabsTrigger value="code" LeadingIcon={CodeIcon}>
                        Code
                    </TabsTrigger>
                    <TabsTrigger value="preview" LeadingIcon={FileTextIcon}>
                        Preview
                    </TabsTrigger>
                </TabsList>

                <div className="mt-3 rounded-md border border-border-subtle bg-surface-muted">
                    {!isPreviewMode ? (
                        <MarkdownCopyablePre className="px-4 py-3 font-mono text-sm">
                            <code className="language-yaml">{content}</code>
                        </MarkdownCopyablePre>
                    ) : (
                        <WorkflowPreview content={content} />
                    )}
                </div>
            </Tabs>
        </div>
    );
};
